import getGoogleAdUnitApiFactory from '../../modules/googleAd/googleAdApi';

/* Utils */
import {generateDefaultAsyncSaga, generateDefaultAsyncWatcher} from '../core/reduxUtils';

/* Actions */
import {getGoogleAdUnitListingPageActionCreators} from '../actions/googleAdUnitActions';

function googleAdUnitSagasFactory({storefrontApiClient}) {
  const googleAdUnit = getGoogleAdUnitApiFactory(storefrontApiClient);

  const getGoogleAdUnitListingPage = generateDefaultAsyncSaga(
    googleAdUnit.getGoogleAdUnit,
    getGoogleAdUnitListingPageActionCreators,
    payload => [
      payload.body,
    ]
  );

  const watchGetGoogleAdUnitComponents = generateDefaultAsyncWatcher(
    'GET_GOOGLE_AD_UNIT_LISTING_PAGE',
    getGoogleAdUnitListingPage,
  );

  const googleAdUnitSagas = [
    watchGetGoogleAdUnitComponents(),
  ];

  return googleAdUnitSagas;
}

export default googleAdUnitSagasFactory;
